import { getServerTimeString } from 'app/core/http';
import { Exception } from 'app/core/status';

/**
 * To get the server time.
 */
export async function initialServerTime(surveyHash: string) {
  try {
    return await getServerTimeString(surveyHash);
  } catch (error) {
    throw new Exception('NOT_FOUND');
  }
}
